import { Link } from "react-router-dom";
import "./contactUs.scss";
import { useEffect } from "react";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="contactUs__container">
        <div direction="[object Object]" className="contactUs__main">
          <div className="contactUs__content">
            <section direction="column" className="contactUs__section">
              <span className="contactUs__span">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.654 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM812.8C7.8417812.8 7.6871 12.7531 7.55555 12.6652C7.42399 12.5773 7.32145 12.4523 7.2609 12.3061C7.20035 12.16 7.18451 11.9991 7.21537 11.8439C7.24624 11.6887 7.32243 11.5462 7.43432 11.4343C7.5462 11.3224 7.68874 11.2462 7.84393 11.2154C7.99911 11.1845 8.15997 11.2003 8.30615 11.2609C8.45233 11.3214 8.57727 11.424 8.66518 11.5555C8.75308 11.6871 8.8 11.8418 8.8 12C8.8 12.2122 8.71572 12.4157 8.56569 12.5657C8.41566 12.7157 8.21217 12.8 8 12.8ZM9.4968 8.3664C9.29518 8.478649.12543 8.640339.00353 8.83627C8.88163 9.0322 8.81159 9.25593 8.8 9.4864V9.6C8.8 9.81217 8.71572 10.0157 8.56569 10.1657C8.41566 10.3157 8.21217 10.4 8 10.4C7.78783 10.4 7.58435 10.3157 7.43432 10.1657C7.28429 10.0157 7.2 9.81217 7.2 9.6V9.4872C7.21143 8.9869 7.34951 8.49767 7.60133 8.06523C7.85316 7.63278 8.21052 7.27124 8.64 7.0144C8.85955 6.87509 9.02833 6.6687 9.12128 6.42587C9.21424 6.18303 9.22641 5.9167 9.156 5.6664C9.10186 5.46954 8.99754 5.29011 8.853245.14567C8.70894 5.001238.52961 4.89673 8.3328 4.8424C8.15118 4.79165 7.96022 4.78395 7.77511 4.81992C7.58999 4.85589 7.41581 4.93453 7.2664 5.0496C7.12075 5.16143 7.00288 5.30537 6.92199 5.47022C6.84109 5.63507 6.79934 5.81637 6.8 6C6.8 6.21217 6.71572 6.41565 6.56569 6.56568C6.41566 6.71571 6.21217 6.8 6 6.8C5.78783 6.8 5.58435 6.71571 5.43432 6.56568C5.28429 6.41565 5.2 6.21217 5.2 6C5.19709 5.31933 5.44223 4.6609 5.88957 4.14786C6.33691 3.63483 6.95582 3.30231 7.630553.2125C8.30528 3.1227 8.989623.28175 9.55558 3.65991C10.1215 4.03808 10.5304 4.60946 10.7056 5.2672C10.8594 5.8452 10.8251 6.45715 10.6077 7.01437C10.3904 7.57159 10.0013 8.04514 9.4968 8.3664Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              <p className="style--one--p">پرسش‌های متداول</p>
              <p color="weak" className="style--two--p">
                پاسخ خود را بیابید
              </p>
              <p className="style--three--p">
                <a href="/faq" className="style--three--p--a">
                  پرسش‌ها{/* */}{" "}
                </a>
              </p>
            </section>
            <div className="contactUs__section--divider" />
            <section direction="column" className="contactUs__section">
              <span className="contactUs__span">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={22}
                  viewBox="0 0 32 22"
                  fill="currentColor"
                >
                  <path
                    d="M31.9795 1.68982L20.7305 11.0674L31.9986 18.5748V1.90118C31.9986 1.8291 31.9912 1.75877 31.9795 1.68982Z"
                    fill="currentColor"
                  />
                  <path
                    d="M19.7174 11.9199L18.2994 13.102C17.6332 13.6574 16.8166 13.9351 16 13.9351C15.1834 13.9351 14.3668 13.6574 13.7006 13.102L12.2826 11.9199L0 20.1031V20.2717C0 20.97 0.56756 21.5382 1.26512 21.5382H30.7347C31.4323 21.5382 31.9998 20.97 31.9998 20.2717V20.1031L19.7174 11.9199Z"
                    fill="currentColor"
                  />
                  <path
                    d="M30.7419 0.64209C30.7404 0.64209 30.7388 0.64209 30.7373 0.64209H1.26765C1.26609 0.64209 1.26459 0.64209 1.26303 0.64209C1.0844 0.642778 1.00709 0.870585 1.14434 0.98502L12.7244 10.6381C12.7257 10.6392 12.7271 10.6404 12.7285 10.6416L14.5127 12.1288C15.3759 12.8485 16.6291 12.8485 17.4924 12.1288L30.8606 0.98502C30.9979 0.870522 30.9205 0.642716 30.7419 0.64209Z"
                    fill="currentColor"
                  />
                  <path
                    d="M0.0190624 1.68982C0.00743746 1.75877 0 1.82897 0 1.90118V18.5748L11.2681 11.0673L0.0190624 1.68982Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <p className="style--one--p">ارسال ایمیل</p>
              <p color="weak" className="style--two--p">
                پاسخگویی در سریع ترین زمان
              </p>
              <p className="style--three--p">
                <a
                  href="mailto:contact@filmnet.ir"
                  className="style--three--p--a"
                >
                  contact@qoraani.com
                </a>
              </p>
            </section>
            <div className="contactUs__section--divider" />
            <section direction="column" className="contactUs__section">
              <span className="contactUs__span">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={32}
                  height={33}
                  viewBox="0 0 32 33"
                  fill="currentColor"
                >
                  <path
                    d="M31.3777 25.7731L27.8302 23.4053L24.6765 21.301C24.0679 20.8956 23.25 21.0285 22.8007 21.6059L20.8493 24.1173C20.4301 24.6622 19.676 24.8188 19.0749 24.4856C17.7508 23.7483 16.185 23.054 12.7302 19.591C9.27536 16.128 8.57743 14.5649 7.84087 13.2394C7.50807 12.6376 7.6645 11.8827 8.20887 11.4632L10.7175 9.50962C11.2942 9.05989 11.427 8.24107 11.0221 7.63173L8.98461 4.57188L6.55483 0.923213C6.14127 0.302171 5.31341 0.115721 4.67404 0.499571L1.871822.1825C1.11452.62917 0.557838 3.35045 0.317091 4.19679C-0.449213 6.99373 -0.60371 13.1637 9.27367 23.0518C19.151 32.9399 25.3137 32.7847 28.1076 32.0175C28.9531 31.7766 29.6735 31.2193 30.1197 30.4611L31.8008 27.6559C32.1843 27.0158 31.9981 26.1871 31.3777 25.7731Z"
                    fill="currentColor"
                  />
                  <path
                    d="M18.2079 5.26844C23.3855 5.2742 27.5814 9.4746 27.5871 14.6579C27.5871 14.9629 27.8341 15.2102 28.1389 15.2102C28.4436 15.2102 28.6906 14.9629 28.6906 14.6579C28.6842 8.86481 23.9947 4.1702 18.208 4.16382C17.9033 4.16382 17.6563 4.41108 17.6563 4.71616C17.6562 5.02112 17.9032 5.26844 18.2079 5.26844Z"
                    fill="currentColor"
                  />
                  <path
                    d="M18.208 8.58476C21.5582 8.5887 24.2729 11.3064 24.2769 14.6601C24.2769 14.9651 24.5239 15.2124 24.8286 15.2124C25.1333 15.2124 25.3804 14.9651 25.3804 14.6601C25.3758 10.6966 22.1673 7.48467 18.208 7.4801C17.9033 7.4801 17.6562 7.72736 17.6562 8.03243C17.6562 8.3375 17.9032 8.58476 18.208 8.58476Z"
                    fill="currentColor"
                  />
                  <path
                    d="M18.2079 11.9007C19.7307 11.9025 20.9647 13.1379 20.9665 14.6624C20.9665 14.9674 21.2135 15.2147 21.5183 15.2147C21.8229 15.2147 22.07 14.9674 22.07 14.6624C22.0676 12.5281 20.3399 10.7985 18.208 10.796C17.9033 10.796 17.6563 11.0433 17.6563 11.3484C17.6562 11.6534 17.9032 11.9007 18.2079 11.9007Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              <p className="style--one--p">تماس با پشتیبانی</p>
              <p color="weak" className="style--two--p">
                همه روزه از ساعت ۸:۳۰ الی ۲۴:۰۰
              </p>
              <p className="style--three--p">
                <a href="tel:02158172444" className="style--three--p--a">
                  021{/* */}-{/* */}88809098
                </a>
                {/* <a href="tel:02158172555" class="style--three--p--a">021-58172555</a> */}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
